export const MUTATION_DELETE_D_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteDepositCase(id: $id)
	}
`;
